module.exports = __webpack_public_path__ + "static/media/serverlessComputing.e1b06c8a.jpg";